import { Button, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { MpAuthContainer } from '../../containers/microfrontends/MpAuthContainer/MpAuthContainer';
import { IProposalInfo } from '../../types/proposal';
import imgIcon from './img/bicycle.svg';
import cianLogo from './img/cianLogo.svg';
import xIcon from './img/x.svg';
import style from './style.css';

export interface ILoginProps {
  proposalInfo: IProposalInfo;
  isAuthorized: boolean;
  onTopButtonClick(): void;
}

export const LoginComponent: React.FC<ILoginProps> = ({ proposalInfo, isAuthorized, onTopButtonClick }) => {
  const { bankInfo } = proposalInfo;

  function scrollToCalc() {
    const calculatorBlock = document.querySelector('#calc-widget');
    calculatorBlock?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div className={style['wrapper']}>
      <div className={style['widget']}>
        <div className={style['logo']}>
          <img src={cianLogo} alt="cian logo" />
          <img src={xIcon} alt="x" />
          <img src={bankInfo.icon} alt="bank logo" />
        </div>
        {/* eslint-disable-next-line no-irregular-whitespace */}
        <span className={style['title']}>Выберите квартиру на вторичке со скидкой на ипотеку 4%</span>
        {isAuthorized ? (
          <UIText1>Банк проверит ваши данные через Госуслуги</UIText1>
        ) : (
          <UIText1>
            Мы уже договорились с продавцами и банком: по условиям программы вы получите скидку 4% от базовой ставки
          </UIText1>
        )}
        {!isAuthorized ? (
          <div className={style['mp-auth-container-wrapper']}>
            <MpAuthContainer />
          </div>
        ) : (
          <div className={style['btn-wrapper']}>
            <a href={bankInfo.redirectLink}>
              <Button fullWidth onClick={onTopButtonClick}>
                Отправить заявку в банк через Госуслуги
              </Button>
            </a>
            <Button theme="fill_secondary" onClick={scrollToCalc} fullWidth>
              Рассчитать ипотеку
            </Button>
          </div>
        )}
      </div>
      <img src={proposalInfo.ratePicName || imgIcon} alt="background" className={style['bicycle']} />
    </div>
  );
};
